import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Loader, PageTitle } from 'components/atoms'
import { ListGrid } from 'components/organisms'
import { Search } from 'components/templates'
import { contentTypesNames } from 'interfaces/contentTypeInterface'
import { EVENTS, GENERAL_EVENTS, SPORT_EVENTS } from 'constants/appConstants'
import * as S from './styled'

const ContentType = ({
  zone,
  searchMode,
  search,
  searchQuery,
  handleStatus,
  contentType,
  onScroll,
  listInnerRef,
  items,
  isLoading,
}) => {
  const navigate = useNavigate()
  return (
    <>
      {searchMode ? (
        <Search search={search} searchQuery={searchQuery} zone={zone} handleStatus={handleStatus} />
      ) : (
        <S.Container onScroll={onScroll} ref={listInnerRef}>
          <S.TitleContainer>
            {(contentType === EVENTS || contentType === GENERAL_EVENTS || contentType === SPORT_EVENTS) && (
              <S.ButtonsContainer>
                <Button
                  label='General'
                  classBtn='filter'
                  selected={contentType === GENERAL_EVENTS}
                  handleClick={() => navigate(`/${GENERAL_EVENTS}`)}
                />
                <Button
                  label='Sports'
                  classBtn='filter'
                  selected={contentType === SPORT_EVENTS}
                  handleClick={() => navigate(`/${SPORT_EVENTS}`)}
                />
              </S.ButtonsContainer>
            )}
            <PageTitle title={contentTypesNames(contentType)} />
          </S.TitleContainer>

          {isLoading && <Loader />}

          {items.length > 0 && <ListGrid items={items} contentType={contentType} />}
        </S.Container>
      )}
    </>
  )
}

ContentType.defaultProps = {
  search: [] || {},
  searchMode: false,
  handleStatus: () => {},
  onScroll: () => {},
  searchQuery: '',
}

ContentType.propTypes = {
  zone: PropTypes.string.isRequired,
  search: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  searchMode: PropTypes.bool,
  handleStatus: PropTypes.func,
  contentType: PropTypes.string.isRequired,
  onScroll: PropTypes.func,
  listInnerRef: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  searchQuery: PropTypes.string,
}

export default ContentType
